import { v4 as uuidv4 } from 'uuid'

import type { Nominal, NominalUUID, Nullable } from '../../lib/typeHelpers.no-deps'
import type { FileExtension } from './fileExtensions.no-deps'
import type { BucketType } from '../../lib/aws/s3.no-deps'

export type FileId = NominalUUID<'FileId'>
export type FileName = Nominal<string, 'FileName'>
export const generateFileId = () => assertFileId(uuidv4())
export const assertFileId = (fileId: string) => fileId as FileId
export const assertFileName = (fileName: string) => fileName as FileName

export type FileType = 'file' | 'photo' | 'video'
export type FileStatus = 'started' | 'processing' | 'complete'
export type MediaType = 'PhotoFile' | 'VideoFile'

export interface FileMeta extends FileMetaBase {
    lastModified: Date
    bucketReference: Nullable<BucketType>
    status: FileStatus
    fileKey: Nullable<string>
    thumbnailKey: Nullable<string>
    isDeleted: boolean
    createdBy: Nullable<number>
    lastModifiedBy: Nullable<number>
}

interface FileMetaBase {
    fileId: FileId
    fileName: FileName
    fileSizeInBytes: number
    extension: FileExtension
    createdAt: Date
}

// These are the only fields required by the app
export interface FileMetaApp extends FileMetaBase {
    status: FileStatus
    fetchUrl: string
    isDeleted: boolean
    createdBy: Nullable<number>
    lastModifiedBy: Nullable<number>
}

export type AddInput = Omit<FileMetaBase, 'createdAt' | 'fileId'> & {
    fileId?: FileId
    createdAt?: Date
}
